import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../globals';
import { BaseLayerExclusionFields } from '../../../shared/settings/BaseLayerExclusionFields';
import Section from '../../../shared/settings/SettingsPageSection';
import useOrganizationSettings from '../../shared/useOrganizationSettings';
import type { ContainerIssueSettings } from '../../../../../shared/settings/project/issues';

import PropagateContainerModal from './PropagateContainerModal';
import { getEndpoint } from './utils';

/**
 * SettingsOrganizationProjectIssuesContainers is the settings page for
 * managing the default container scanning settings for projects.
 */
export const SettingsOrganizationProjectIssuesContainers: VoidFunctionComponent = () => {
  const [isPropagateModalOpen, setIsPropagateModalOpen] = useState<boolean>(false);
  const {
    settings,
    isLoading,
    onUpdateSettings,
    onSaveSettings,
    isSaveButtonDisabled,
  } = useOrganizationSettings<ContainerIssueSettings>({
    endpoint: getEndpoint(window.user?.organizationId as number, 'container'),
    settingsSection: 'project container',
  });
  return (
    <>
      <Section>
        <Section.Left heading="Containers">
          <Section.Paragraph>
            Default behavior of container-based projects.
          </Section.Paragraph>
          <Section.Buttons>
            <Section.PropagateButton
              onClick={() => setIsPropagateModalOpen(true)}
              isDisabled={!isSaveButtonDisabled}
            />
            <Section.SaveButton
              onClick={onSaveSettings}
              isLoading={isLoading.save}
              isDisabled={isSaveButtonDisabled}
            />
          </Section.Buttons>
        </Section.Left>
        <Section.Right>
          <BaseLayerExclusionFields
            excludeLicensingIssues={!!settings?.projectDefaultExcludeBaseLayerIssuesLicensing}
            onToggleExcludeLicensingIssues={(isChecked) => onUpdateSettings({
              projectDefaultExcludeBaseLayerIssuesLicensing: isChecked,
            })}
            excludeSecurityIssues={!!settings?.projectDefaultExcludeBaseLayerIssuesSecurity}
            onToggleExcludeSecurityIssues={(isChecked) => onUpdateSettings({
              projectDefaultExcludeBaseLayerIssuesSecurity: isChecked,
            })}
            excludeQualityIssues={!!settings?.projectDefaultExcludeBaseLayerIssuesQuality}
            onToggleExcludeQualityIssues={(isChecked) => onUpdateSettings({
              projectDefaultExcludeBaseLayerIssuesQuality: isChecked,
            })}
          />
        </Section.Right>
      </Section>
      {settings && (
        <PropagateContainerModal
          settings={settings}
          isOpen={isPropagateModalOpen}
          onHide={() => setIsPropagateModalOpen(false)}
        />
      )}
    </>
  );
};
